






import Vue from 'vue';
import { Island } from '.';

export default Vue.extend({
  name: 'DashboardIsland',
  components: {
    Island,
  },
  props: {
    padded: {
      type: Boolean,
      default: false,
    },
  },
});
